/**
 * 页面的Mixin , 提取公共部分
 * create by sevencai@20180829
 * contact sevencai@tencent.com
 */
import { getParam, addGetParam } from '@tencent/midas-util'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      showToast: false
    }
  },

  methods: {
    /**
     * 跳转到 item 对应的链接并上报
     */
    /* eslint-disable no-nested-ternary */
    linkAds(item, index: number | string, iformat: string, isBtnDisabled?: boolean, pfStructure?: string) {
      if (isBtnDisabled) {
        this.showToast = true

        setTimeout(() => {
          this.showToast = false
        }, 3000)
        return
      }

      this.jumpHref({
        link: item.link || item.url,
        pfStructure
      })

      this.log(`${iformat}${index}`, item.adsId ? { adsId: item.adsId } : item.groupId ? { groupId: item.groupId } : undefined)
    },

    /**
     * 修改pf后跳转
     */
    jumpHref({ link, pfStructure }: { link: string; pfStructure?: string }) {
      const pf = getParam('pf') + (pfStructure ? `.${pfStructure}` : '')
      const url = addGetParam({ pf }, link)
      window.location.href = url
    },

    /**
     * 广告曝光上报方法
     * @param index 当前广告轮播index
     * @param item
     * @param iformat 埋点
     */
    reportAdsPV(index: number | string, { adsId = '', groupId = '' }: ReportItem, iformat: string) {
      this.log(iformat, {
        index,
        adsId,
        groupId
      })
    }
  }
})
